import fetchTopicTree from './action-topic-list';
import getFaqList, { requestArticles } from './action-faq-list';

export default function getArticleListByTopic(topicSelected, experience, L3TopicClicked, isL3TopicPage) {
  return (dispatch, getState) => {
    const { topicList } = getState();
    if (L3TopicClicked || !isL3TopicPage) {
      dispatch(requestArticles()); // when clicked on L2 topic bread crumb triggering spinner
      dispatch(fetchTopicTree(experience, topicSelected)).then((response) => {
        if (response && response.payload) {
          dispatch(getFaqList(response.payload, topicSelected));
        }
      });
    } else {
      dispatch(getFaqList(topicList, topicSelected));
    }
  };
}
